import React from 'react';
import View from "react-native-web/dist/exports/View";
import PropTypes from 'prop-types';
import StackView from '../../StackView';
import { useCarousel } from '../CarouselContext';
import CarouselTabsPanelItem from './CarouselTabsPanelItem';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const selectTabPanelStyle = () => ({
  backgroundColor: 'transparent'
});
const CarouselTabsPanel = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    items
  } = _ref;
  const {
    activeIndex,
    goTo
  } = useCarousel();
  const nextFocusRef = React.useRef();
  const firstTabRef = React.useRef();
  const [isInverse, setIsInverse] = React.useState(false);
  const lastTabSelected = activeIndex === items.length - 1;

  // Get current select tab style
  React.useEffect(() => {
    const [selectedVariantIsInverse] = items.filter((_, index) => index === activeIndex);
    setIsInverse(selectedVariantIsInverse?.inverse);
  }, [items, activeIndex]);

  // TODO: figure out a better cross-brand way to specify subcomponent variants.
  // For now, this picks an Allium variant, and does nothing in brands that lack it.
  // See similar comment in Carousel and https://github.com/telus/universal-design-system/issues/1549
  const dividerVariant = {
    decorative: true,
    inverse: isInverse
  };
  return /*#__PURE__*/_jsxs(View, {
    style: selectTabPanelStyle(),
    children: [/*#__PURE__*/_jsx(StackView, {
      direction: "row",
      space: 3,
      divider: {
        variant: dividerVariant,
        accessibilityRole: 'presentation',
        accessibilityOrientation: null
      },
      ref: ref,
      accessibilityRole: "tablist",
      children: items.map((_ref2, index) => {
        let {
          title,
          onPress,
          inverse,
          ...panelItemProps
        } = _ref2;
        const selected = index === activeIndex;
        const isNext = index === activeIndex + 1;

        // Selected item should be always unfocusable and unpressable
        const handlePress = selected ? undefined : event => {
          if (typeof onPress === 'function') onPress(event, index);
          goTo(index);
        };
        return /*#__PURE__*/_jsx(CarouselTabsPanelItem, {
          ref: isNext && nextFocusRef || index === 0 && firstTabRef || null,
          title: title,
          selected: selected,
          onPress: handlePress,
          variant: {
            inverse: isInverse
          },
          ...panelItemProps
        }, title);
      })
    }), /*#__PURE__*/_jsx(View, {
      focusable: true,
      accessible: true,
      ref: lastTabSelected ? nextFocusRef : null
    })]
  });
});
CarouselTabsPanel.displayName = 'CarouselTabsPanel';
CarouselTabsPanel.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape(CarouselTabsPanelItem.propTypes || {})),
  // Color defined by `Carousel.item` variant otherwise fallback to transparent
  contentBackgroundColor: PropTypes.string
};
export default CarouselTabsPanel;